export enum FoulType {
  EXCL = 'EXCL',
  EDCS = 'EDCS',
  PEN = 'PEN'
}

export enum FoulPosition {
    EXT = 'EXT',
    CB = 'CB', 
    CF = 'CF',
    OTHER = 'OTHER'
}

export enum EDCSType {
    BRUTALITA = 'BRUTALITA', 
    GIOCO_VIOLENTO = 'GIOCO_VIOLENTO',
    PROTESTE = 'PROTESTE'
}

 export enum FoulDescription {
    WITH = 'Con palla',
    WITHOUT = 'Senza palla'
 }